import { useMemo } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const QueryClientConfig = ({ children }) => {
    const queryClient = useMemo(() => new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                retry: false,
            },
        },
    }), []);

    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    );
};
